import { apiGet } from './auth'

/** One staircase step in the COL grid. */
export interface GridScenario {
  transactions_per_day: number
  revenue_per_day_eur: number
  hours_per_day: number
  hours_per_week: number
  hours_per_year: number
}

/** Response of `GET /api/v1/grid/view`: the complete curve for one shop. */
export interface GridView {
  store_id: number
  store_code: string
  store_name: string
  grid_id: string
  grid_label: string
  aov_eur: number
  minimum_transactions_per_day: number
  maximum_transactions_per_day: number
  minimum_daily_sales_eur: number
  maximum_daily_sales_eur: number
  scenarios: GridScenario[]
  source: 'col_labor_grid'
}

export interface GridViewParams {
  storeId: number
  /** TanStack Query passes this so a superseded shop aborts its fetch. */
  signal?: AbortSignal
}

export function fetchGridView({ storeId, signal }: GridViewParams): Promise<GridView> {
  return apiGet<GridView>('/grid/view', { store_id: storeId }, signal)
}
